import { DatePipe } from '@angular/common'
import { CreateTicketFormFields } from '../tickets/createTicketFormFields'
import { TicketsService, PartsService,MessageService } from '../../services'
import { BartTicket } from 'src/app/models/tickets/bart.ticket'
import { Injectable } from '@angular/core'
import { ConfirmationService } from 'primeng/api';
@Injectable({
    providedIn: 'root'
})
export class BartTicketValidate {
    datePiepe = new DatePipe('en-US')
    private formFields: CreateTicketFormFields;
    constructor
        (
            private _ticketService: TicketsService,
            private _bartTicket: BartTicket,
            private _partsService: PartsService,
            private _confirmationService: ConfirmationService,
            private _messageService:MessageService
        ) {
        this._ticketService.getTicketGlobalData().subscribe((Result: any) => {
            this.formFields = Result; //Get Latest Update value from here
        },
            (error) => {
                // handle error here
            }
        );
    }
    public validateColumn1(slideColumns) {
        if (this.formFields) {
            var facilityMasterId = this.formFields.selectedFacilityId //$('#facilityMasterId').val();
            var isScheduledFlag = null;
            var isUnscheduledFlag = null
            // var isScheduledFlag = $('#isScheduledFlag').val();
            // var isUnscheduledFlag = $('#isUnscheduledFlag').val();
            if (this.formFields.ScheduledRadioButtonselectedValue == "yes") {
                isScheduledFlag = 1
            }
            else if (this.formFields.ScheduledRadioButtonselectedValue == "no") {
                isUnscheduledFlag = 1;
            }
            var workTypeId = this.formFields.selectedWorkTypeId //$('#workTypeId').val();
            //var equipmentId = this.formFields.selectedEquipmentList[0].EquipmentID
            var dateServiceRequested = this.formFields.srRequestedDate //$('#dateServiceRequested').val();

            var dateServiceBegan = this.formFields.srBeginDate //$('#dateServiceBegan').val();
            var dateServicePerformed = this.formFields.srCompletedDate //$('#dateServicePerformed').val();

            var errors = new Array();
            var msg = "";
            var i = 0;
            var isValid = false;

            var dateServiceRequested = this.datePiepe.transform(dateServiceRequested, "MM/dd/yyyy") //$.datepicker.parseDate('mm/dd/yy',$('#dateServiceRequested').val());
            var dateServiceBegan = this.datePiepe.transform(dateServiceBegan, "MM/dd/yy")//$.datepicker.parseDate('mm/dd/yy',$('#dateServiceBegan').val());
            var dateServicePerformed = this.datePiepe.transform(dateServicePerformed, "MM/dd/yy") 
            var completeDateMin = "";
            var completeDateMax = "";
            this.formFields.ispartsUsedRadioDisabled = true;
         
            var ticketMinDate = this.datePiepe.transform(this.formFields.ticketMinDate, "MM/dd/yy") //new Date();
            var ticketMaxDate = this.datePiepe.transform(this.formFields.ticketMaxDate, "MM/dd/yy") //new Date();

            var enforcePastDate = true;
            if (this.formFields.TicketId != null && this.formFields.TicketId > 0)
                enforcePastDate = false;
        }

        ticketMinDate = this.datePiepe.transform(ticketMinDate, "yyMMdd");  
        ticketMaxDate = this.datePiepe.transform(ticketMaxDate, 'yyMMdd');

        if (dateServiceRequested != null) {
            dateServiceRequested = this.datePiepe.transform(dateServiceRequested, 'yyMMdd'); 
            if (enforcePastDate) {
                if (parseInt(dateServiceRequested) < parseInt(ticketMinDate)) {
                    errors.push('Service Requested Date cannot be more than 45 days in the past.');
                    //this.formFields.srRequestedDate=null //Blank TextBox if date invalid
                }
                if (parseInt(dateServiceRequested) > parseInt(ticketMaxDate)) {
                    errors.push('Service Requested Date cannot be after today.');
                    //this.formFields.srRequestedDate=null //Blank TextBox if date invalid
                }
            }
        }
        if (dateServiceBegan != null) {
            dateServiceBegan = this.datePiepe.transform(dateServiceBegan, 'yyMMdd');   //$.datepicker.formatDate('yymmdd',dateServiceBegan);
            if (enforcePastDate) {
                if (parseInt(dateServiceBegan) < parseInt(ticketMinDate)) {
                    errors.push('Service Began Date cannot be more than 45 days in the past.');
                    //this.formFields.srBeginDate=null //Blank TextBox if date invalid
                }
                if (parseInt(dateServiceBegan) > parseInt(ticketMaxDate)) {
                    errors.push('Service Began Date cannot be after today.');
                    //this.formFields.srBeginDate=null //Blank TextBox if date invalid
                }
            }
        }
        if (dateServiceRequested != null && dateServiceBegan != null && dateServicePerformed != null) {
            dateServicePerformed = this.datePiepe.transform(dateServicePerformed, 'yyMMdd',) //$.datepicker.formatDate('yymmdd',dateServicePerformed);
            if (enforcePastDate) {
                if (parseInt(dateServicePerformed) < parseInt(ticketMinDate)) {
                    errors.push('Actual Service Date cannot be more than 45 days in the past.');

                }
                if (parseInt(dateServicePerformed) > parseInt(ticketMaxDate)) {
                    errors.push('Actual Service Date cannot be after today.');
                }
            }
            if (parseInt(dateServiceRequested) > parseInt(dateServiceBegan)) {
                errors.push('Service Began Date must be the same or later than the Service Request Date.');
            }
            if (parseInt(dateServiceRequested) > parseInt(dateServicePerformed)) {
                errors.push('Actual Service Date must be the same or later than the Service Request Date.');
            }
            if (parseInt(dateServiceBegan) > parseInt(dateServicePerformed)) {
                errors.push('Actual Service Date must be the same or later than the Service Began Date.');
            }
            if (completeDateMin != "" && completeDateMax != "") {   //Not in used for Non Batch Ticket
                if (dateServicePerformed < completeDateMin || completeDateMax < dateServicePerformed) {
                    errors.push('Service Completed date is not within the required date period (' + completeDateMin + '-' + completeDateMax + ')');
                }
            }
            this.formFields.ispartsUsedRadioDisabled = false

        }
        else {
            if (dateServiceRequested == null || dateServiceBegan == null) {
                errors.push('');
            }
        }
        if (facilityMasterId != facilityMasterId) {
            errors.push('You must choose a location');
        }
        if (eval(isScheduledFlag) != 1 && eval(isUnscheduledFlag) != 1) {
            errors.push('Is the maintenance scheduled?');
        }
        if (workTypeId != workTypeId) {
            errors.push('Choose a work type');
        }
        for (i; i < errors.length; i++) {
            msg = msg + errors[i] + '\n';
        }
        if (errors.length) {
            if (msg.length > 1) {
                //alert(msg);
                this._messageService.showAlertMessage(msg);
            };
            //$('#column2').hide();
            //$('#column3').hide();
            this.formFields.isShowColumn2 = false
            this.formFields.isShowColumn3 = false
        }
        else {
            isValid = true;
            if (slideColumns) {
                this._bartTicket.enableColumns();
            }
        }
        return isValid;


    }

    public validateStandardTicket() {
        var i = 0;
        var msg = "";
        var ticketValid = false;
        var errors = new Array();
        var hoursNumeric = true;
        var testEquipCount = 0;
        var hoursWork = this.formFields.hoursWorkedSel + this.formFields.minutesWorkedSel
        var hoursTravel = this.formFields.hoursTravelSel + this.formFields.minutesTravelSel
        //////////////////////////////////////////////////////////////////////////////
        //CHECK THE NUMERIC FIELDS////////////////////////////////////////////////////
        //////////////////////////////////////////////////////////////////////////////



        if (this.formFields.selectedWorkTypeId == 0 || this.formFields.selectedWorkTypeId == undefined) {
            errors.push('Please check Service Type (workTypeId)');
        }

        if (this.formFields.isBatchTicket == undefined) {
            errors.push('Please check Service Type (isBatchFlag)');
        }
        if (this.formFields.selectedSQACodeId == 0 || this.formFields.selectedSQACodeId == undefined) {
            errors.push('Please check SQA code');
        }
        // if ((hoursWork == 0 || hoursWork == undefined)) {
        //     errors.push('Please check Hours Worked');
        // }
        //Start:Commented By Harikesh on 13-Oct-2020 for Issue#12243
        // if (hoursTravel == 0 || hoursTravel == undefined) {
        //     errors.push('Please check Hours Traveled');
        // }
        //End:Commented By Harikesh on 13-Oct-2020 for Issue#12243
        if (this.formFields.selectedpayRollId== 0 || this.formFields.selectedpayRollId == undefined) {
            errors.push('Please check Payroll Code');
        }
        if (this.formFields.isServiceMatchFindingsFlag == undefined || this.formFields.isServiceMatchFindingsFlag == null || this.formFields.isServiceMatchFindingsFlag == '') {
            errors.push('Please check Service Match Findings');
        }
        if(this.formFields.findings==undefined || this.formFields.findings==null || this.formFields.findings=="")
        {
            errors.push('Please check  Findings');
        }

        //CHECK THE HOURS WORKED
        if (hoursWork == 0 || hoursWork==undefined ) {
            errors.push('Hours Worked cannot be zero.');
        }


        if (this.formFields.ispartsUsedRadio == 'false' || this.formFields.ispartsUsedRadio ==null) {
            errors.push('Please check Parts used during repair?');
        }

        if (this.formFields.istestEquipUsedRadio == 'false' || this.formFields.istestEquipUsedRadio==null) {
            errors.push('Please check Test Equipment used?');
        }
        if (this.formFields.testEquipmentUsedDuringRepair != null) {
            for (let i = 0; i < this.formFields.testEquipmentUsedDuringRepair.length; i++) {
                testEquipCount++;
            }
            // if (this.formFields.istestEquipUsedRadio == 'true' && testEquipCount == 0) {
            //     errors.push('Please select Test Equipment used.');
            // }
        }
        if (this.formFields.istestEquipUsedRadio == 'yes' && testEquipCount == 0) {
            errors.push('Please select Test Equipment used.');
        }

        ////////////////////////////	CLOCK HOUR CHECKS SECTION	////////////////////////////


        //IF THE EQUIPMENT IS A DIALYSIS MACHINE REQUIRE THE CLOCK HOURS BE ENTERED
        if (this.checkClockHours() == false) {
            errors.push('Please check Current Hours');
        }

        //PRODUCT SERVICE COMPLAINT CHECK
        if (this.formFields.ismeritComplaint == null || this.formFields.ismeritComplaint == undefined) {
            errors.push('Does service merit a product Or process complaint?');
            if (this.formFields.ismeritComplaint == 'yes') {
                if (this.formFields.selectedQuestionId != 0 || this.formFields.selectedQuestionId != undefined) {
                    errors.push('Please choose a product/process complaint reason');
                }
            }
        }





        ////////////////////////////	CHECK THE STRING FIELDS 	////////////////////////////


        if (this.formFields.srRequestedDate == undefined) {
            errors.push('Please check Service Requested Date');
        }
        if (this.formFields.srBeginDate == undefined) {
            errors.push('Please check Service Began Date');
        }
        if (this.formFields.srCompletedDate == undefined) {
            errors.push('Please check Actual Service Date');
        }
        if (this.formFields.serviceRequested== undefined || this.formFields.serviceRequested==null || this.formFields.serviceRequested=="") {
            errors.push('Please check Service Requested');
        }
        // if(this.formFields.isServiceMatchFindingsFlag==undefined)
        // {
        //     errors.push('Please check Findings');
        // }
        if (this.formFields.workPerformed == undefined || this.formFields.workPerformed == null || this.formFields.workPerformed == '') {
            errors.push('Please check Work Performed');
        }
        for (i; i < errors.length; i++) {
            msg = msg + errors[i] + '\n';
        }

        if (errors.length) {
            if (msg.length > 1) {
                //alert(msg);  Commented By Harikesh on 25-June-2020
                this._messageService.showAlertMessage(msg); 
            }
        } else {
            ticketValid = true;
        }
        return ticketValid;
    }
    public validateBatchTicket(batchTicketObj) {
        var errors = new Array();
        var isValid = false;
        var msg = '';
        var i = 0;

        if (batchTicketObj.facilityMasterId != parseInt(batchTicketObj.facilityMasterId)) {
            errors.push('You must choose a location');
        }
        if (batchTicketObj.isScheduledFlag != parseInt(batchTicketObj.isScheduledFlag)) {
            errors.push('Is the maintenance scheduled?');
        }
        if (batchTicketObj.workTypeId != parseInt(batchTicketObj.workTypeId)) {
            errors.push('Choose a work type');
        }
        if (batchTicketObj.isBatchFlag != true) {
            errors.push('Choose a work type (isBatchFlag)');
        }

        var dateServiceRequested = this.datePiepe.transform(batchTicketObj.dateServiceRequested, "MM/dd/yyyy")
        var dateServiceBegan = this.datePiepe.transform(batchTicketObj.dateServiceBegan, "MM/dd/yyyy")
        var dateServicePerformed = this.datePiepe.transform(batchTicketObj.dateServicePerformed, "MM/dd/yyyy")
        var completeDateMin = "";
        var completeDateMax = "";
        var cvalidateBatchTicketompleteDateMax = "";
        var ticketMinDate = new Date();
        var ticketMaxDate = this.datePiepe.transform(new Date(), "MM/dd/yyyy");
        ticketMinDate.setDate(ticketMinDate.getDate() - 45);

        //service complete date [4]
        if (this.formFields.batchMeasure != undefined) {

            let completeDateObj = this.formFields.batchMeasure.filter(x => x.discreteMeasureAttributeId == 4);
            if (completeDateObj && completeDateObj.length > 0) {
                completeDateMin = this.datePiepe.transform(completeDateObj[0].minDate, "MM/dd/yyyy")
                completeDateMax = this.datePiepe.transform(completeDateObj[0].maxDate, "MM/dd/yyyy")
            }
        }


        if (dateServiceRequested != null && dateServiceBegan != null && dateServicePerformed != null) {
            if (new Date (dateServiceRequested).setHours(0,0,0,0) > new Date (dateServiceBegan).setHours(0,0,0,0)) {
                errors.push('Service Began Date must be the same or later than the Service Request Date.');
            }
            if (new Date (dateServiceRequested).setHours(0,0,0,0) > new Date(dateServicePerformed).setHours(0,0,0,0)) {
                errors.push('Actual Service Date must be the same or later than the Service Request Date.');
            }
            if (new Date (dateServiceBegan).setHours(0,0,0,0) > new Date( dateServicePerformed).setHours(0,0,0,0)) {
                errors.push('Actual Service Date must be the same or later than the Service Began Date.');
            }
            if (new Date (dateServiceRequested).setHours(0,0,0,0) < new Date( this.datePiepe.transform(ticketMinDate, "MM/dd/yyyy")).setHours(0,0,0,0)) {
                errors.push('Service Requested Date cannot be more than 45 days in the past.');
            }
            if (new Date (dateServiceBegan).setHours(0,0,0,0) < new Date (this.datePiepe.transform(ticketMinDate, "MM/dd/yyyy")).setHours(0,0,0,0)) {
                errors.push('Service Began Date cannot be more than 45 days in the past.');
            }
            if (new Date(dateServicePerformed).setHours(0,0,0,0) < new Date (this.datePiepe.transform(ticketMinDate, "MM/dd/yyyy")).setHours(0,0,0,0)) {
                errors.push('Service Performed Date cannot be more than 45 days in the past.');
            }
            if (completeDateMin != "" && completeDateMax != "") {
                if ( new Date(dateServicePerformed).setHours(0,0,0,0) < new Date (completeDateMin).setHours(0,0,0,0) || new Date (completeDateMax).setHours(0,0,0,0) < new Date (dateServicePerformed).setHours(0,0,0,0)) {
                    errors.push('Service Completed date is not within the required date period (' + completeDateMin + '-' + completeDateMax + ')');
                }
            }
        } else {
            errors.push('Please check the dates entered.');
        }

        if (batchTicketObj.hoursWork != parseFloat(batchTicketObj.hoursWork)) {
            errors.push('Please enter time worked.');
        }
        if (parseFloat(batchTicketObj.hoursWork) == 0) {
            errors.push('Hours Worked cannot be zero.');
        }
        if (batchTicketObj.hoursTravel != parseFloat(batchTicketObj.hoursTravel)) {
            errors.push('Please enter time travelled.');
        }
        if (batchTicketObj.payrollCodeId != parseInt(batchTicketObj.payrollCodeId)) {
            errors.push('Please choose a payroll code.');
        }

        if (this.formFields.isShowAdditionalComment) {
            if (this.formFields.additionalComment.length <= 2) {
                errors.push('Additional comments must contain at least 3 characters.');
            }
        }

        for (i = 0; i < errors.length; i++) {
            msg += errors[i] + '\n';
        }

        if (errors.length) {
            if (msg.length > 1) {
                //alert(msg); Commented by Harikesh on 25-June-2020
                this._messageService.showAlertMessage(msg);
            }
        } else {
            isValid = true;
        }
        return isValid;
    }
    public checkClockHours() {
        var hoursOk = false;
        var lastRecordedHours = this.formFields.lastRecordedHours;
        var clockHours = this.formFields.clockHours;
        var sqaCode = this.formFields.selectedSQACodeId
        var sqaOverride = 0;
        var msg = "";

        if (sqaCode == 112) {
            sqaOverride = 1;
        }

        if (this.formFields.TicketId != undefined) {
            if (this.formFields.hasclock == 0 || this.formFields.hasclock == null) {
                hoursOk = true;
                msg = "";
            }
        }

        if (sqaOverride == 1) {
            hoursOk = true;
            msg = "";
        }

        if (this.formFields.hasclock <= 0) {
            hoursOk = true;
            msg = "";
        }

        if (hoursOk == false) {
            //CHECK THE CLOCK HOURS ARE GREATER THAN OR EQUAL TO THE LAST RECORDED HOURS UNLESS IT'S A CLOCK REPAIR
            if (clockHours < lastRecordedHours) {
                msg = 'Current Hours cannot be less than Last Recorded Hours.';
            }

            if (this.formFields.clockHours == null && this.formFields.clockHours == undefined) {
                msg = 'Current Hours are required to continue.';
            }
        }
        if (msg != "") {
            //alert(msg); Commented By Harikesh on 25-June-2020
            this._messageService.showAlertMessage(msg);
            hoursOk = false;
        } else {
            hoursOk = true;
        }
        return hoursOk;
    }

    public checkSpelling(field) {
        return true

    }
    public checkEletricalLeakage(equipmentId) {
        return true

    }
    public checkGroundWireResistance(equipmentId) {
        return true

    }
    public checkBatchClockHours(equipmentId) {
        return true

    }
    public validateElecSafety(equipmentId, showAlert) {
        return true

    } 
}